import { Dispatch, SetStateAction } from "react";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import { Modal, Button, MenuItem } from "@mui/material";

interface ModalProps {
  open: boolean;
  onClose: () => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
}

export default function CreateIncident({
  open,
  onClose,
  setOpen,
}: ModalProps) {
  return (
    <Modal
      className="modal rejectReason_modal"
      open={open}
      onClose={onClose}
    >
      <div className="modal-dialog take_action_modal">
        <div className="modal-body">

          {/* Header */}
          <div className="modal_title">
            <h2>Create Incident</h2>
            <button
              type="button"
              className="btn-close"
              onClick={() => setOpen(false)}
              aria-label="Close"
            >
              <CloseIcon />
            </button>
          </div>

          {/* Form */}
          <form className="form">
            <div className="gap_p">

              {/* Incident Title */}
              <div className="control_group w_50">
                <label htmlFor="incident-title">
                  Incident Title <span className="required">*</span>
                </label>

                <TextField
                  placeholder="Enter incident title"
                  fullWidth
                  hiddenLabel
                  inputProps={{ id: "incident-title" }}
                />
              </div>

              {/* Severity */}
              <div className="control_group w_50">
                <label htmlFor="incident-severity">
                  Severity <span className="required">*</span>
                </label>

                <TextField
                  select
                  fullWidth
                  hiddenLabel
                  defaultValue=""
                  SelectProps={{ displayEmpty: true }}
                  inputProps={{ id: "incident-severity" }}
                >
                  <MenuItem value="" disabled>
                    Select severity
                  </MenuItem>
                  <MenuItem value="critical">Critical</MenuItem>
                  <MenuItem value="high">High</MenuItem>
                  <MenuItem value="medium">Medium</MenuItem>
                  <MenuItem value="low">Low</MenuItem>
                </TextField>
              </div>

              {/* Affected Service */}
              <div className="control_group  w_50">
                <label htmlFor="incident-service">
                  Affected Service <span className="required">*</span>
                </label>

                <TextField
                  select
                  fullWidth
                  hiddenLabel
                  defaultValue=""
                  SelectProps={{ displayEmpty: true }}
                  inputProps={{ id: "incident-service" }}
                >
                  <MenuItem value="" disabled>
                    Select service
                  </MenuItem>
                  <MenuItem value="payment">Payment Service</MenuItem>
                  <MenuItem value="ai">AI Engine</MenuItem>
                  <MenuItem value="database">Database</MenuItem>
                  <MenuItem value="cdn">CDN</MenuItem>
                  <MenuItem value="api">API Gateway</MenuItem>
                  <MenuItem value="auth">Auth Service</MenuItem>
                </TextField>
              </div>

              {/* Estimated Affected Users */}
              <div className="control_group w_50">
                <label htmlFor="incident-affected-users">
                  Estimated Affected Users
                </label>

                <TextField
                  type="number"
                  placeholder="e.g. 1200"
                  fullWidth
                  hiddenLabel
                  inputProps={{ id: "incident-affected-users" }}
                />
              </div>

              {/* Description */}
              <div className="control_group">
                <label htmlFor="incident-description">
                  Description <span className="required">*</span>
                </label>

                <TextField
                  multiline
                  rows={4}
                  placeholder="Describe the incident in detail"
                  fullWidth
                  hiddenLabel
                  inputProps={{ id: "incident-description" }}
                />
              </div>

            </div>

            {/* Footer */}
            <div className="footer_btn_flex">
              <Button
                className="btn btn_grey"
                variant="outlined"
                onClick={() => setOpen(false)}
              >
                Cancel
              </Button>

              <Button
                className="btn btn_primary"
                onClick={() => setOpen(false)}
              >
                Create Incident
              </Button>
            </div>
          </form>

        </div>
      </div>
    </Modal>
  );
}
